import { useState, useEffect, useCallback, useRef } from 'react'

// Deps
import omit from 'lodash/omit'

// Functions
import isExact from 'functions/is-exact'

const useQuery = (queryStringProp, defaultQuery, filterOpenExclusions, forbiddenKeys = []) => {
	const filterOpenExclusionList = useRef(filterOpenExclusions);
	const forbiddenKeysList = useRef(forbiddenKeys);

	const calculateQuery = useCallback((queryString) => {
		let paramQuery = {};
		if(queryString) {
			let filtersArray = queryString.split('&');

			for(const newFilter of filtersArray) {
				let filterArray = newFilter.split('=');
				if(filterArray.length === 2 && !forbiddenKeysList.current.includes(filterArray[0])) {
					paramQuery[filterArray[0]] = decodeURIComponent(filterArray[1]);
				}
			}
		}

		let query = {
			...defaultQuery,
			...paramQuery,
		}

		let urlQuery = {...query};

		for(const key in query) {
			if((defaultQuery[key] === '' && urlQuery[key] === '') || (defaultQuery[key] === urlQuery[key])) {
				delete urlQuery[key];
			}
		}

		return [query, urlQuery, (Object.keys(omit(urlQuery, filterOpenExclusionList.current)).length > 0)];
	}, [defaultQuery]);

	const [queryData, setQueryData] = useState(calculateQuery(queryStringProp));

	useEffect(() => {
		let newQuery = calculateQuery(queryStringProp);
		if(!isExact(newQuery, queryData)) {
			setQueryData(newQuery);
		}

	}, [queryStringProp, calculateQuery, queryData])

	return queryData;
}

export default useQuery;